import { fg } from '@confluence/feature-gating';
import type { IEnvironment, MutationConfig, MutationParameters } from 'relay-runtime';
import { commitMutation as relayCommitMutation } from 'relay-runtime';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import { normalizeRelayError } from './normalizeRelayError.ts';

export const commitMutation = <TMutation extends MutationParameters>(
	relayEnvironment: IEnvironment,
	mutation: MutationConfig<TMutation>,
): Promise<TMutation['response']> =>
	new Promise((resolve, reject) => {
		relayCommitMutation<TMutation>(relayEnvironment, {
			...mutation,
			onCompleted: (response, errors) => {
				if (errors) {
					reject(
						new ApolloErrorInterop({
							graphQLErrors: errors.map((error) => ({ ...error, path: error.path?.map(String) })),
						}),
					);
				}
				resolve(response);
			},
			onError: (error) => {
				reject(fg('confluence_relay_parity_fixes') ? normalizeRelayError(error) : error);
			},
		});
	});
